import { useState } from "react";
import Container from "react-bootstrap/Container";
import { Link } from "react-router-dom";
import Francies from "../Home/Francies";
import BulkOrders from "../Home/BulkOrders";
import CallIcon from '@mui/icons-material/Call';
import MailIcon from '@mui/icons-material/Mail';
import theme from "../Theme";
import LocationOnIcon from '@mui/icons-material/LocationOn';

const Footer = () => {
  const [isFranciesOpen, setIsFranciesOpen] = useState(false);
  const [isBulkOpen, setIsBulkOpen] = useState(false);

  const openulkModal = () => {
    setIsBulkOpen(true);
  };

  const closeModal = () => {
    setIsFranciesOpen(false);
  };
  const closeBulkModal = () => {
    setIsBulkOpen(false);
  };

  return (
    <>
      <Francies open={isFranciesOpen} closeModal={closeModal} />
      <BulkOrders open={isBulkOpen} closeModal={closeBulkModal} />
      <section className="footer-sec py-4">
        <Container>
          <div className="row">
            <div className="col-lg-3 col-md-6 col-sm-12">
              <div>
                <Link to="/">
                  <img
                    className="img-fluid footer-logo"
                    alt="Footer-logo"
                    src="/assets/newlogo.png"
                    loading="lazy"
                  />
                </Link>
                <p className="logo-para pt-3">
                  Your trusted source for premium halal meat with over 20 years of excellence. 100% organic, fresh, and delivered with care.
                </p>
                <div className="foot-links">
                  {/* <h2>Follow Us :</h2> */}
                  <div className="social-media">
                    <a
                      href="https://www.instagram.com/meatmarket_buyonline/"
                      target="_blank"
                    >
                      <i className="fi fi-brands-instagram"></i>
                    </a>
                    <a
                      className="mx-4"
                      href="https://www.facebook.com/profile.php?id=61564134010130"
                      target="_blank"
                    >
                      <i className="fi fi-brands-facebook"></i>
                    </a>
                    <a href="https://x.com/MarketMeat38607" target="_blank">
                      <i className="fi fi-brands-twitter-alt-circle"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-12 d-lg-flex justify-content-center">
              <div className="foot-links">
                <h2>Quick Links</h2>
                <ul className="px-0">
                  <li>
                    <Link to="/chicken">Chicken</Link>
                  </li>
                  <li>
                    <Link to="/mutton">Mutton</Link>
                  </li>
                  <li>
                    <Link to="/prawn">Prawn</Link>
                  </li>
                  <li>
                    <Link to="/fish&sea-foods">Fish & Sea Foods</Link>
                  </li>
                  <li>
                    <Link to="/forzen-foods">Forzen Foods</Link>
                  </li>
                  <li>
                    <Link to="/Blogs">Blogs</Link>
                  </li>
                  {/* <li>
                    <a onClick={openulkModal}>For Bulk Orders</a>
                  </li> */}
                  {/* <li>
                    <a onClick={openModal}>Become A Franchise</a>
                  </li> */}
                  {/* <li>
                    <Link to="/my-order">My Orders</Link>
                  </li> */}
                </ul>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-12  d-lg-flex justify-content-center">
              <div className="foot-links">
                <h2>More Info</h2>
                <ul className="px-0">
                  <li>
                    <Link to="/about-us">About Us</Link>
                  </li>
                  <li>
                    <Link to="/termsandconditions">Terms and conditions</Link>
                  </li>
                  <li>
                    <Link to="/privacy-policy">Privacy policy</Link>
                  </li>
                  <li>
                    <Link to="/refund-policy">Refund Policy</Link>
                  </li>
                  <li>
                    <Link to="/contact-us">Contact Us</Link>
                  </li>
                  {/* <li>
                    <Link to="/about-us">Customer Service</Link>
                  </li>
                  <li>
                    <Link to="/termsandconditions">Terms and conditions</Link>
                  </li>
                  <li>
                    <Link to="/privacy-policy">Privacy policy</Link>
                  </li>
                  <li>
                    <Link to="/refund-policy">Refund policy</Link>
                  </li>
                  <li>
                    <Link to="/contact-us">Contact us</Link>
                  </li> */}
                </ul>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-12">
              <div className="foot-links">
                <h2>Contact For Any Info</h2>
                <p>
                  Always at your Disposal For Any Questions. Fell Free To
                  Contact Us.
                </p>
                <div className="navCall">
                  <a href="tel:+91 9789983465">
                   <CallIcon className="me-2" style={{color:theme.color.pri}}/>  +91 9789983465
                  </a>
                </div>
                <div className="navCall py-2">
                  <a href="mailto:info@meatmarket.live">
                   <MailIcon className="me-2" style={{color:theme.color.pri}}/>  info@meatmarket.live
                  </a>
                </div>
               
              </div>
              {/* <div>
                <img
                  className="img-fluid"
                  style={{ width: "100px" }}
                  src="/assets/fssai.png"
                  loading="lazy"
                  alt="img"
                />
              </div> */}
            </div>
          </div>
        </Container>
      </section>
      <div className="text-center py-3">
     
      <p  className="mb-0" style={{ fontSize: "16px", fontWeight: 600 }}>Copyrights @ {new Date().getFullYear()} <strong>Meat Market</strong> designed & developed by <a style={{color:"#000",textDecoration:"none"}} href="https://www.thetechhorse.com/">The TechHorse</a></p>

      </div>
    </>
  );
};

export default Footer;
